// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".creator-point[data-v-48ff4e64]{display:flex;align-items:center}.creator-point__img[data-v-48ff4e64]{font-size:14px;position:relative;display:inline-block}.creator-point__empty-star[data-v-48ff4e64]{color:#ddd}.creator-point__filled-star[data-v-48ff4e64]{color:#ffb100;position:absolute;top:0;overflow:hidden;white-space:nowrap}.creator-point__text[data-v-48ff4e64]{font-size:12px;margin-left:6px}", ""]);
// Exports
module.exports = exports;
